import { render } from "./orderList.vue?vue&type=template&id=97435dfa&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"

import "./orderList.vue?vue&type=style&index=0&id=97435dfa&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97435dfa"],['__file',"src/views/my/orderList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97435dfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97435dfa', __exports__)) {
    console.log('reload')
    api.reload('97435dfa', __exports__)
  }
  
  module.hot.accept("./orderList.vue?vue&type=template&id=97435dfa&scoped=true", () => {
    console.log('re-render')
    api.rerender('97435dfa', render)
  })

}


export default __exports__